export class AppConstant {
  // public static APP_BASE_URL = 'http://localhost:5000';
  // public static APP_BASE_URL = 'http://108.168.203.227/storebuilder';

  // Login API
  public static LOGIN = '/Account/Login';
  public static SIGNUP = '/Account/SignUp';
  public static CheckDuplicateEmail = '/Account/CheckDuplicateEmail';
  public static FORGOT_PASSWORD = '/Account/ForgotPassword';
  public static RESET_PASSWORD = '/Account/ResetPassword';
  public static EMAIL_CONFIRM = '/Account/ConfirmEmail';
  public static ADDW9SFormDetails = '/Account/AddW9SDetails';
  public static SubscribeNewsletter = '/Account/SubscribeNewsletter';
  public static CHECK_INVITATION_TOKEN = '/Account/CheckInvitationTkn';
  public static ACCEPT_INVITATION = '/Account/AcceptInvitation';
  public static LOGIN_INKSOFT = '/Account/LoginInksoft';


  //  add by rahul on 06/05/2019

  public static GetDesignDetails = '/Design/GetDesignDetails';
  public static GetGAInfo = '/Account/GetGAInfo?storeUrl=';
  //end

  // added by priyanka on 05/09/2019
  public static GetStoreCategoryList = '/Store/GetStoreCategoryList?userid=';
  //end
  // STORECATEGORY API
  public static STORECATEGORY_LIST = '/Store/GetStoreCategoryQuery';
  public static CREATE_STORECATEGORY = '/Store/CreateStoreCategory';
  public static STORE_CREATE = '/Store/CreateStore';
  public static STORE_UPDATE = '/Store/UpdateStore';
  public static STORE_UPDATE_DESIGN = '/Store/UpdateStoreDesign';
  public static STORE_UPDATEKEY = '/Store/UpdateStoreKey';
  public static STORE_GET = '/Store/GetStoreById?storeid=';
  public static STORE_GETALL = '/Store/GetStoreList';
  public static DASHBOARDSTORE_GETALL = '/Dashboard/GetStoreList';
  public static ISSORENAMEALREADYEXIST = '/Store/GetStoreAutoComplete';
  public static GET_STORES_FOR_PRODUCT_PUBLISH = '/Store/GetStoresForProductPublish';
  public static SHOPIFY_STORE_GET = '/Store/GetShopifyStore';
  public static SHOPIFY_STORE_ADD = '/Store/AddShopifyStore';


  // Upload Design API
  public static UPLOADDESGIN_CREATE = '/Design/UploadDesign';
  public static UPLOADDESGIN_LIST = '/Design/GetUploadedDesigns';
  public static UPLOADDESGIN_EDIT = '/Design/GetUploadedDesignById?UploadedDesignId=';
  public static UPLOADDESGIN_UPDATE = '/Design/UpdateUploadedDesign';
  public static UPLOADDESGIN_DELETE = '/Design/DeleteUploadedDesign';

  // Country State API
  public static COUNTRY_LIST = '/Common/GetCountryList';
  public static STATE_BYCOUNTRY_GET = '/Common/GetStateByCountry?countryId=';

  // Inksoft and Product API
  public static GET_PRODUCT_CATEGORIES = '/Category/GetCategoryQuery';
  public static GET_PRODUCTBYCATEGORY = '/Product/GetProductByCategory';
  public static GET_FILTERS = '/Product/GetFilters';
  public static GET_PRODUCTDETAIL_BY_ID_Style = '/Product/GetCutomizedProductDetailsByProductIdWithStyle';
  public static GET_CUSTOMIZED_PRODUCT_DETAIL_BY_ID = '/Product/GetCutomizedProductDetailsByProductId';
  public static GET_CUSTOMIZED_WAREHOUSE_PRODUCT_DETAIL_BY_ID = '/Product/GetCustomizedWarehouseProductId';
  public static GET_CUSTOMIZED_PRODUCT_FILTERS = '/Product/GetCustomizedProductFilters';
  public static GET_CUSTOMIZED_PRODUCTS = '/Product/GetCustomProductList';
  // WI-1579: single-store Active/Draft toggle (single + bulk) for the SuperAdmin Shopify Products page.
  public static UPDATE_STORE_PRODUCT_STATUS = '/Product/UpdateStoreProductStatus';
  public static SAVE_CUSTOMIZED_PRODUCT = '/Product/SaveCustomizedProduct';
  public static UPDATE_CUSTOMIZED_PRODUCT = '/Product/UpdateCustomizedProduct';
  public static GET_AVG_RATING = '/Product/GetAverageRating';
  public static GET_PRODUCT_REVIEWS = '/Product/GetProductReview';
  public static SAVE_PRODUCT_IMAGES = '/Product/UploadProductImages';
  public static SAVE_DEFAULT_PRODUCT_IMAGE = '/Product/UpdateDefaultProductImage';
  public static SAVE_CUSTOM_IMAGE_FLAG = '/Product/UpdateShowCustomImageFlag';
  public static GET_SIZE_QTY = '/Product/GetProductInventoryInfo';
  public static GET_OUT_OF_STOCK_PRODUCTS = '/Product/GetOutOfStockProducts';
  public static UPDATE_OUT_OF_STOCK_ACTION = '/Product/UpdateOutOfStockAction';
  public static MARK_OUT_OF_STOCK_DISCONTINUED = '/Product/MarkOutOfStockProductDiscontinued';
  public static GET_OUT_OF_STOCK_SUMMARY = '/Product/GetOutOfStockSummary';
  public static GET_OUT_OF_STOCK_PRODUCTS_V2 = '/Product/GetOutOfStockProductsV2';
  public static GET_OUT_OF_STOCK_PRODUCT_DETAIL = '/Product/GetOutOfStockProductDetail';
  public static RECHECK_RESTORE_OUT_OF_STOCK = '/Product/RecheckAndRestoreOutOfStock';
  public static REACTIVATE_RESTORE_OUT_OF_STOCK = '/Product/ReactivateAndRestoreOutOfStock';
  // Master product APIs
 
  public static GET_PRODUCT_FEATURES_FILE = '/Product/DownloadProductsFeatures';
  public static GET_SHIP_COST_FILE = '/Product/DownloadProductShipCost';
  public static GET_PRODUCTS = '/Product/GetProductList';
  public static GET_MASTER_PRODUCT_FILTERS = '/Product/GetMasterProductFilters';
  public static GET_PRODUCTDETAIL_BY_ID = '/Product/GetProductDetailsByProductId';
  public static UPLOAD_PRODUCT_FEATURES = '/Product/UploadProductsFeatures';
  public static GET_ADDITIONAL_PRODUCT_DETAILS = '/Product/GetAdditionalProductDetails';
  public static GET_MY_SAVED_DESIGN = '/Product/GetMySavedDesign';
  public static UPLOAD_PRODUCT_SHIPCOST = '/Product/UploadProductShipCost';
  // ML Shopify Node app APIs
  public static ADD_PRODUCT_SHOPIFY = '/api/product/raw';
  public static ADD_PRODUCT_SHOPIFY_BULK = '/api/product/raw/bulk';
  public static POST_DATA_SHOPIFY = '/api/product/update';
  public static REPLACE_PRODUCT_SHOPIFY = '/api/product/replace';
  public static GET_SHOPIFY_STORE = '/api/product/getapikey';
  public static WAREHOUSE_PRODUCT_CREATE_SHOPIFY = '/api/warehouseproduct/create';
  public static WAREHOUSE_INVENTORY_ADD_SHOPIFY = '/api/warehouseproduct/inventory/add';

  // Warehouse Product APIs
  public static ADD_CUSTOM_PRODUCT = '/Product/SaveCustomProduct';
  public static GET_ALL_CUSTOM_PRODUCT = '/Product/GetAllCustomProduct';
  public static GET_REASSIGN_STORES = '/Product/GetReassignStores';
  public static GET_REASSIGN_STORE_USERS = '/Product/GetReassignStoreUsers';
  public static GET_REASSIGN_PREVIEW = '/Product/GetReassignPreview';
  public static REASSIGN_CUSTOM_PRODUCTS = '/Product/ReassignCustomProducts';
  public static REASSIGN_WAREHOUSE_PRODUCTS = '/Product/ReassignWarehouseProducts';
  public static GET_FLAGSHIP_UNASSIGNED_GROUPS = '/Product/GetFlagshipUnassignedGroups';
  public static GET_FLAGSHIP_GROUP_PRODUCTS = '/Product/GetFlagshipGroupProducts';
  public static GET_ALL_CUSTOM_PRODUCT_DETAILS = '/Product/GetCustomProductDetail';
  public static UPDATE_APPROVAL_OF_CUSTOM_PRODUCT = '/Product/UpdateCustomProductApproval';
  public static ADD_INVENTORY_DETAILS = '/WarehouseShipment/AddWarehouseShipment';
  public static Get_SHIPMENT_DETAILS = '/WarehouseShipment/GetShipmentDetails';
  public static SAVE_PRODUCT_ACTUAL_COUNT = '/WarehouseShipment/SaveProductActualQuantity';
  public static UPDATE_RETAILPRICE_FOR_WAREHOUSE = '/WarehouseShipment/UpdateWareHouseRetailPrice';
  public static DELETE_WAREHOUSE_PRODUCT = '/Store/DeleteWareHousePublishProduct';
  public static DELETE_WAREHOUSE_PRODUCT_FROM_LIST = '/Product/DeleteWareHouseProduct';
  public static GET_WAREHOUSE_INVENTORY_PAYMENT_LIST = '/Product/GetInventoryHoldingPayments';
  public static SAVE_WAREHOUSE_INVENTORY_PAYMENT = '/Product/SaveInventoryHoldingPayment';


  //User Service
  public static ADD_OPEN_API_USER= '/OpenApi/AddOpenAPIUser';
  public static ADD_OPEN_API_USER_LIST = '/OpenApi/AddOpenAPIUserList';
  public static ADD_CUSTOMER_SUPPORT = '/Account/AddCustomerSupportUser';
  public static UPDATE_CUSTOMER_SUPPORT = '/Account/UpdateCustomerSupportUser';
  public static CUSTOMER_SUPPORT_USER_LIST = '/Account/GetCustomerServiceUserList';
  public static CUSTOMER_SUPPORT_USER = '/Account/GetCustomerServiceUser';
  public static CHANGE_STATUS_CUSTOMER_SUPPORT_USER = '/Account/DeleteCustomerServiceUser';
  public static RESEND_INITIAL_EMAIL = '/Account/ResendInitialEmailCSRUser';
  public static DELETED_USER_QUESTIONARE = '/Account/DeletedUserQuestionare';
  public static GetShippingCost = '/Common/GetShippingCost';
  // Account/Profile API -----------------------------------------------------
  public static Profile_GET = '/Account/GetProfileInfo?userId=';
  public static Profile_SAVE = '/Account/SaveProfileInfo';
  public static SubmitTokenNonce = '/Account/SubmitBrainTreeToken';
  public static SUBMIT_BRAINTREE_PAYMENT = '/Account/SubmitBrainTreePayment';
  public static GET_PAYMENT_TOKEN = '/Account/GetPaymentClientToken';
  // --------------------------------------------------------------------------

  // ------------------------------------- Store API -------------------------------------
  /** Save Publish Product */
  public static PUBLISH_STORE_PRODUCT = '/Store/SaveStorePublishProduct';
  public static DUPLICATE_PRODUCT_PUBLISH = '/Store/CheckDuplicateStoreProductPublish';

  /**Get customized products for store front */
  public static GET_STOREFRONT_PRODUCTS = '/Store/GetStorePublishProductList';

  /**Get customized products filters for store front */
  public static GET_CUSTOMIZED_PUBLISH_PRODUCT_FILTERS = '/Store/GetStorePublishedProductFilter';
  public static DeleteCustomizedProduct = '/Product/DeleteCustomizedProduct';
  /**Get customized products filters for store front */
  public static GET_STOREBYNAME = '/Store/GetStoreByName';
  /**Update store theme */
  public static UPDATE_STORETHEME = '/Store/UpdateStoreTheme';
  /**Reset store theme */
  public static RESET_STORETHEME = '/Store/ResetStoreTheme';
  /**Commission list for any store admin */
  public static STOREADMIN_COMMISSION_LIST = '/Store/GetStoreCommissionList';
  // -------------------------------------------------------------------------------------

  /** Cart */
  public static AddItemToCart = '/Cart/AddToCart';
  public static GetCartItems = '/Cart/GetCartItems';
  public static UpdateCart = '/Cart/UpdateCart';
  public static CheckInventoryForWareHouseProduct = '/Cart/CheckWareHouseInventory';
  public static MoveItemsToWishList = '/Cart/MoveItemsToWishList';
  public static CheckCartPrice = '/Cart/CheckCartPrice';
  public static GetThirdPartyShipping = '/Common/GetThirdPartyShipping';
  // ---------------------------------------------------------------------------
  /** WishList */
  public static AddItemToWishList = '/WishList/AddItemToWishList';
  public static GetWishList = '/WishList/GetWishListItem';
  public static DeleteFromWishList = '/WishList/DeleteFromWishList';
  // -------------------------------------------------------------------------------------

  /** Address */
  public static AddAddress = '/Common/AddAddress';
  public static UpdateAddress = '/Common/UpdateAddress';
  public static GetAddressList = '/Common/GetAddressList';
  public static GetAddress = '/Common/GetAddress';
  public static DeleteAddress = '/Common/DeleteAddress';
  // ---------------------------------------------------------------------------

  /** Order */
  public static CreateOrder = '/Order/CreateOrder';
  public static GetOrderList = '/Order/GetOrderList';
  public static ExportOrder = '/Order/ExportOrder';
  public static UpdateSingleOrderToOrderDesk = '/Order/UpdateSingleOrderToOrderDesk';
  public static RequestRegenerateArtworkNo = '/Task/RequestRegenerateArtworkNumber';
  public static GetTranscations = '/Account/GetTranscations';
  public static CancelTranscation = '/Account/CancelTransaction';
  public static GetOrderListShopify = '/Order/GetOrderListShopify';
  public static GetOrderDetail = '/Order/GetOrderDetail';
/*  public static CancelOrder = '/Order/CancelOrder';*/
/*  public static CancelOrderAdmin = '/Order/CancelOrderAdmin';*/
  public static UpdateOrder = '/Order/UpdateOrder';
  public static AddOrderRatingReview = '/Order/AddOrderRatingReview';
  public static GetUserReviewList = '/Order/GetUserReviewList';
  public static ISSUE_REFUND = '/Order/IssueRefund';
  public static GET_CANCEL_ORDER_REQUEST_LIST = '/Order/GetCancelOrderRequests';
  public static UPDATE_CANCEL_ORDER_REQUEST_STATUS = '/Order/UpdateCancelOrderRequestStatus';
  public static REPORT_ORDER = '/Order/ReportOrder';
  public static REPORT_ORDER_REPLACEMENT = '/Order/ReportOrderReplacement';
  public static GET_REPORT_ORDER_REQUEST_LIST = '/Order/GetReportOrderRequests';
  public static UPDATE_REPORT_ORDER_REQUEST_STATUS = '/Order/UpdateReportOrderRequestStatus';
  public static UPLOAD_IMPRESS_INVOICE = '/Order/UploadImpressInvoice';
  public static UPLOAD_MARK_ORDER_SHIPPED_IMPRESS = '/Order/UploadMarkOrderShippedImpress';
  public static BULK_JOBS = '/Order/BulkJobs'; // WI 1711: + '?type=&take=' | '/{id}' | '/{id}/export'
  // OpenAPI order
  public static DOWNLOAD_OPENAPI_INVOICE = '/OpenAPI/DownloadOpenAPIInvoice';
  public static UPLOAD_OPENAPI_INVOICE = '/OpenAPI/UploadOpenAPIInvoice';

  public static REQUEST_ORDER_CANCEL = '/Order/RequestCancelOrder';
  
  // ---------------------------------------------------------------------------

  // -------------------------------- SUPER ADMIN -----------------------------------------
  public static CLIENT_LIST = '/Client/GetClientList';
  public static CLIENT_DETAIL = '/Client/GetClientDetail';
  public static GET_PRODUCT_ASYNC = '/Product/GetProductAsyncFromInkSoft';
  public static GET_PROGRESS_PRODUCT_ASYNC = '/Product/GetProgressProductAsyncFromInkSoft';
  public static GET_SYNCED_PRODUCT_ASYNC = '/Product/GetSyncedProductList';
  public static GET_CAT_QUERY = '/Product/GetProductCategoryQuery';
  public static UPDATE_DETAIL = '/Client/UpdateClientDetail';
  public static UPDATE_DISCOUNT = '/Client/UpdateDiscountForClient';
  public static UPDATE_SOURCE_NAME = '/Client/UpdateSourceName';
  public static UPDATE_ORDER_DESK_CONFIG = '/Client/UpdateOrderDeskConfig';
  public static DELETE_ORDER_DESK_CONFIG = '/Client/DeleteOrderDeskConfig';
  public static UPDATE_SOPHOSTED_VALUE = '/Client/UpdateSOPHostedValue';
  public static ADD_CLIENT = '/Client/AddClient';
  public static UPDATE_CLIENT_DETAIL = '/client/UpdateUserCompanyDetail'
  
  // -------------Store List-------------
  public static SUPER_ADMIN_STORE_LIST = '/Client/GetSuperAdminStoreList';
  public static SUPER_ADMIN_GROUPED_STORE_LIST = '/Client/GetGroupedStoreList';
  public static UPDATE_STORE_OWNER = '/Client/UpdateStoreOwner';
  public static UPDATE_STORE_SHOPIFY_STATUS = '/Store/UpdateStoreShopifyStatus';
  public static SUPER_ADMIN_User_LIST = '/Client/GetAllUserList';
  public static SUPER_ADMIN_RESEND_CONFORMATION_EMAIL = '/Client/ResendConfirmationEmail';
  public static SUPER_ADMIN_RESET_PASSWORD_EMAIL = '/Client/SuperAdminResetPasswordEmail';
  public static SUPER_ADMIN_PERMISSION_LIST = '/Client/GetPermissions';
  public static ADD_PERMISSION_GROUP = '/Client/AddPermissionGroup';
  public static SUPER_ADMIN_PERMISSION_GROUP_LIST = '/Client/GetPermissionGroups';
  public static SAVE_USER_PERMISSIONS = '/Client/SaveUserPermissionGroupList';
  public static GET_PERMISSION_GROUP_USERS = '/Client/GetPermissionGroupUser';
  public static DELETE_PERMISSION_GROUP = '/Client/DeletePermissionGroup';
  public static OPENAPI_CLIENT_LIST = '/Client/GetOpenAPIUsers';

  // ----- Report------------------------
  public static SuperAdminSalesReport = '/Report/GetSuperAdminRptSalesOrderdata';
  public static StoreAdminSalesReport = '/Report/GetStoreAdminRptSalesOrderdata';

  public static SUPER_ADMIN_EARNING_RPT = '/Report/GetSuperAdminEarningReport';
  public static STORE_ADMIN_EARNING_RPT = '/Report/GetStoreAdminEarningReport';
  // -------------Commission List-------------
  public static COMMISSION_LIST = '/Commission/GetCommissionList';
  public static UPDATE_ORDER_COMMISSION = '/Commission/UpdateOrderCommission';
  public static UPDATE_PAYPAL_PAYOUT_STATUS = '/Commission/GetCommissionStatus';
  // -----------Published Product on Store By Store Admin------------
  public static STOREADMIN_PUBLISHED_PRODUCT_LIST = '/Store/GetStoreAdminPublishedProductList';
  public static UPDATE_STOREADMIN_PUBLISHED_PRODUCT_LIST = '/Store/UpdatePublishedProductRetailPrice';
  public static DELETE_STOREADMIN_PUBLISHED_PRODUCT_LIST = '/Store/DeletePublishedProduct';
  public static Delete_Store = '/store/DeleteStore';
  // ------------- SuperAdmin Dashboard -------------
  public static GET_SUPER_ADMIN_DASHBOARD_DATA = '/Dashboard/GetSuperAdminDashboardData';
  public static GET_TOTAL_ENDUSERS_OFSTORE = '/Dashboard/GetTotalEndUsersOfStore';
  public static GET_ORDERS_PER_STORE = '/Dashboard/GetOrdersPerStore';
  public static GET_SUPER_ADMIN_REVENUE_CHART_DATA = '/Dashboard/GetSuperAdminRevnueChartData';

  // ------------- StoreAdmin Dashboard -------------
  public static GET_STORE_ADMIN_DASHBOARD_DATA = '/Dashboard/GetStoreAdminDashboardData';
  public static UPDATE_DAILY_VISITOR_CR = '/Dashboard/UpdateDailyVistor';
  public static UPDATE_DESIGN_VIEWED_COUNT = '/Dashboard/UpdateDesignViewedCount';
  public static GET_OPEN_CARTS_QUERY = '/Dashboard/GetOpenCartsQuery';
  public static GET_DAILY_VISITORS = '/Dashboard/GetDailyVisitors';
  public static GET_DESIGN_VIEWED_COUNT = '/Dashboard/GetDesignViewedCount';


  // ------------- About Store -----------------------
  public static GET_ABOUT_STORE = '/Common/AboutStore';
  public static GET_STORE_PERMISSION = '/Common/GetStorePermission?userId='
  // ------------- Privacy Policy, Terms Of Use -----------------------
  public static ADD_UPDATE_PRIVACYPOLICY_TERMSOFUSE = '/Common/AddUpdateApplicationSetting';
  public static GET_PRIVACYPOLICY_TERMSOFUSE = '/Common/GetApplicationSetting';
  public static POST_UPLOAD_FILE = '/Common/UploadFile';
  public static POST_UPLOAD_HUDDLE_LOGO = '/Common/upload-huddle-logo';
  public static POST_SAVE_HUDDLE_CUSTOMIZED_PRODUCTS = '/api/designhuddle/SaveHuddleCustomizedProducts';

  //--------------------InvoiceList-------------------------------
  public static GET_INVOICE_LIST = '/Common/GetInvoiceDetails';
  public static GET_DETAILED_INVOICE_LIST = '/Common/GetDetailedInvoice';

  //--------------------Bug-------------------------------
  public static SUBMIT_BUG = '/Bug/SubmitBug';

  //--------------------Request Color-------------------------------
  public static SUBMIT_REQUEST_COLOR = '/Bug/SubmitRequestColor';

  //--------------------Product Request (Customer Portal)-------------------------------
  public static PRODUCT_REQUEST_GET_ALL = '/ProductRequest/GetAll';
  public static PRODUCT_REQUEST_GET_BY_ID = '/ProductRequest/GetById/';
  public static PRODUCT_REQUEST_DECLINE = '/ProductRequest/Decline';
  public static PRODUCT_REQUEST_SAVE_CUSTOMIZATION = '/ProductRequest/SaveCustomization';
  public static PRODUCT_REQUEST_ADD_LOG = '/ProductRequest/AddLog';

  //---------------------Categories------------------------
  public static GET_PRODUCT_CATEGORIES_LIST = '/Common/GetProductCategories';
  public static GET_PRODUCT_SUB_CATEGORIES_LIST = '/Common/GetProductSubCategories';
  //----------------------------Encrypt---------------------------
  public static ENCRYPT_DATA = '/Common/GetSecureEncryptedData'
  //----------------------------Warehouse product dropdowns----------
  public static GET_PRODUCT_DROPDOWN_LIST = '/Common/GetProductDropdownData';
  //----------------------------Release note---------

  public static GET_ALL_RELEASE_LIST = '/Dashboard/GetReleaseNote';
  public static SAVE_RELEAE_NOTE = '/Client/SaveReleaseNote';
  public static DISMIS_RELEASE_NOTE = '/Dashboard/DismissReleaseNote';

  //-------------------Account Setting ---------------------
  public static UPDATE_ACCOUNT_SETTING = '/Store/UpdateAccountSetting'

  //-------------------Team Setting ---------------------
  public static SEND_INVITE = '/Store/SendInvite'
  public static UPDATE_PERMISSION = '/Store/UpdateStaffPermission'
  public static GET_COMPANY_MEMBERS = '/Store/GetCompanyMembers?companyId='
  public static GET_INVITED_MEMBERS = '/Store/GetInvitedMembers?companyId='
  public static GET_PERMISSION_LIST = '/Store/GetStorePermission?userId='
  public static GET_BUSINESS_DETAILS = '/Store/GetBusinessDetail?userId='
  public static DELETE_USER = '/Store/DeleteStoreMember?userId='
  public static DEACTIVATE_USER = '/Store/DeactivateStoreMember?userId='

  //-------------------Fundraising Payout Management (Customer Portal API)---------------------
  public static PAYOUT_GET_ALL = '/api/admin/payouts';
  public static PAYOUT_GET_BY_ID = '/api/admin/payouts/';
  public static PAYOUT_APPROVE = '/approve';
  public static PAYOUT_REJECT = '/reject';
  public static FUNDRAISING_CONFIGS_GET_ALL = '/api/finance/fundraising-configs';

}


export class OrderStatus {
  public static Ordered = 1;
  public static Confirmed = 2;
  public static Processing = 3;
  public static Cancelled = 4;
  public static Dispatched = 5;
  public static Delivered = 6;
  public static Produced = 7;

}

export enum CancelOrderRequestStatus {
  Requested = 1,
  Approved = 2,
  Rejected = 3,
}
export enum ReportOrderRequestStatus {
  Requested = 1,
  Approved = 2,
  Rejected = 3,
}

export class PaymentType {
  public static CreditCard = 1;
  public static Paypal = 2;
}

export class ApiStatusCode {
  public static SUCCESS = 200;
  public static NO_DATA_FOUND = 204;
  public static ERROR = 203;
  public static INTERNAL_SERVER_ERROR = 500;
  public static BADREQUEST = 400;
  public static NOTFOUND = 404;
  public static UNAUTHORIZED = 401;
}
export class CryptoKeyValue {
  public static Key = "123456$#@$^@1ERF"
}
export class Constants {
  public static PrintingCostPrice = 5;
  public static ReportOrderWithinDays = 60;
  public static finishingCost = 2.50;
  public static EmbroiderySetUpCost = 25;
  public static ScreenPrint = "Digital Print";
  public static EmbroideryType = "Embroidery";
}
export class UserRoles {
  public static EndUser = "EndUser";
  public static StoreAdmin = "StoreAdmin";
  public static SuperAdmin = "SuperAdmin";
  public static CustomerService = "CustomerService";
  public static StoreOwner = "StoreOwner";
  public static StoreStaffMember = "StoreStaffMember";
}
